import { config, CopyKey } from './copyKey';
const FIVE_SECONDS = 5;
export const getCopyKeyByElaspedTime = secondsElapsed => {
  return secondsElapsed < FIVE_SECONDS ? config[CopyKey.Loading] : config[CopyKey.Analyzing];
};